export interface VentVoice {
  id: number;
  text: string;
  audio: string;
}

export const ventVoiceLibrary: VentVoice[] = [
  "我错了",
  "真的对不起，大人",
  "求求您别生气了",
  "全都是我的不好",
  "是我做事没分寸",
  "是我考虑得太欠缺",
  "惹您不开心，我真的很愧疚",
  "我心里一直惴惴不安",
  "我已经认认真真反省过错了",
  "我愿意写悔过检讨，好好反省",
  "您尽管数落我的问题",
  "我安安静静全部听着",
  "我不会顶嘴，也不会反驳",
  "您怎么批评我，我都认真接受",
  "我不该肆意惹您烦心",
  "我不该莽撞自作主张",
  "是我疏忽犯下了纰漏",
  "我打心底里感到懊悔",
  "不敢奢望您马上原谅",
  "只求大人消消心里的火气",
  "您的情绪比什么都重要",
  "我牢牢记住这次教训",
  "往后做事一定三思而后行",
  "我会改掉身上的坏毛病",
  "事事都会多顾及您的感受",
  "绝不再犯同样的错误",
  "绝不再让您为这件事烦心",
  "我会好好改过，好好弥补",
  "恳请大人宽宥我这一回",
  "我一定好好珍惜这次机会",
  "真的对不起，小主",
  "求您别生气了，都是我的不对",
  "我错了，主人",
  "求求你别生气了",
  "主人都是我的错",
  "主人你罚我吧",
  "主人你打我骂我都可以",
  "大人全都是我的不好",
  "是我做事没分寸，大人饶了我吧",
  "是我考虑的太欠缺",
  "惹你不开心我很愧疚，小主",
  "我认认真真反省过错",
  "我可以写悔过的检讨",
  "你尽管数落我的问题",
  "对不起，饶了我吧大人",
  "主人求您消消火气，都是我的不对",
  "是我做事太莽撞，惹您动怒了",
  "我愿意写检讨书，好好反省",
  "您想骂就骂吧，我绝不顶嘴辩解",
  "所有的过错全部都算在我身上，主人",
  "我不该肆意冒犯惹您满心烦闷",
  "我心里满是懊悔，不敢有怨言",
  "您怎么责罚我，我都心甘情愿，小主",
  "我不该心存侥幸犯下这些疏漏",
  "我时刻都在后悔自己的所作所为",
  "只求您放下怒火不要继续烦闷",
  "不敢奢求您立刻就宽恕于我，大人",
  "我会把这次教训刻在心底里面",
  "往后谨言慎行再也不惹您难过",
  "我会事事顾及您的情绪和感受，主人",
  "但凡您有不满都可以朝我发泄",
  "原谅我这一回吧，小主",
].map((text, index) => ({ id:index + 1, text, audio:`/assets/vent-audio/pin-${index + 1}.mp3` }));

const STORAGE_KEY = "career_vent_voice_rotation_v2";
interface RotationState { bag:number[]; recent:number[] }
type RotationStorage = Pick<Storage, "getItem" | "setItem">;

export function drawVentVoices(count=7, storage?:RotationStorage): VentVoice[] {
  const safeCount = Math.max(1, Math.min(count, ventVoiceLibrary.length));
  const ids = ventVoiceLibrary.map((voice) => voice.id);
  const targetStorage = storage ?? (typeof localStorage === "undefined" ? undefined : localStorage);
  const state = readState(targetStorage, ids);
  if (state.bag.length < safeCount) {
    const alreadyQueued = new Set(state.bag);
    const fresh = shuffle(ids.filter((id) => !alreadyQueued.has(id) && !state.recent.includes(id)));
    const delayedRecent = shuffle(ids.filter((id) => !alreadyQueued.has(id) && state.recent.includes(id)));
    state.bag.push(...fresh, ...delayedRecent);
  }
  const chosen = state.bag.splice(0, safeCount);
  state.recent = [...chosen, ...state.recent.filter((id) => !chosen.includes(id))].slice(0, safeCount);
  try { targetStorage?.setItem(STORAGE_KEY, JSON.stringify(state)); } catch { /* private browsing may block storage */ }
  return chosen.map((id) => ventVoiceLibrary[id - 1]);
}

function readState(storage:RotationStorage|undefined, ids:number[]): RotationState {
  try {
    const value = JSON.parse(storage?.getItem(STORAGE_KEY) || "null") as Partial<RotationState>|null;
    const bag = Array.isArray(value?.bag) ? [...new Set(value.bag.filter((id):id is number => ids.includes(id)))] : [];
    const recent = Array.isArray(value?.recent) ? [...new Set(value.recent.filter((id):id is number => ids.includes(id)))].slice(0,7) : [];
    if (bag.length) return { bag, recent };
  } catch { /* start a new rotation when stored data is invalid */ }
  return { bag:shuffle(ids), recent:[] };
}

function shuffle(values:number[]) {
  const result=[...values];
  for (let index=result.length-1;index>0;index--) {
    const random=new Uint32Array(1); crypto.getRandomValues(random);
    const target=random[0]%(index+1);
    [result[index],result[target]]=[result[target],result[index]];
  }
  return result;
}
